import React from 'react';
import ActionTooltip from 'src/components/ActionTooltip';

interface IProps {
    label: string;
    tooltip?: React.ReactNode;
    children: React.ReactNode;
}

const MetaCard = ({ label, tooltip, children }: IProps) => (
    <div className="rounded-lg shadow-md bg-white px-2 lg:px-4 py-2 lg:py-3 flex flex-col gap-0.5">
        {tooltip ? (
            <ActionTooltip childrenClassName="leading-[18px] !flex" message={tooltip} type="light" openOnHover tooltipPosition="center">
                <span className="text-[12px] leading-[18px] text-grayLight600 font-normal border-b border-dashed border-utilityGray200 cursor-pointer w-fit">{label}</span>
            </ActionTooltip>
        ) : (
            <span className="text-[12px] leading-[18px] text-grayLight600 font-normal">{label}</span>
        )}
        {children}
    </div>
);

export default MetaCard;
